/* eslint-disable  */
import { Autocomplete, TextField, CircularProgress, Paper } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import { useEffect, useState } from 'react'

type AutocompleteInputProps = {
  name: string
  label: string
  service?: (searchCriteria: string) => Promise<{ data: DropdownOptionsType[] }>
  onChange?: (value: DropdownOptionsType | DropdownOptionsType[] | null) => void
  onOptionSelect?: () => void
  onClear?: () => void
  cantidadCaracteres?: number
  defaultOptions?: DropdownOptionsType[],
  multiple?: boolean
}

export type DropdownOptionsType = {
  id?: number
  value: string | number
  label: string
}

const CustomPaper = (props: any) => (
  <Paper
    {...props}
    sx={{
      boxShadow: 0,
    }}
  />
);

const CustomAutocompleteInput: React.FC<AutocompleteInputProps> = ({
  name,
  label,
  service,
  onChange,
  onOptionSelect,
  onClear,
  cantidadCaracteres,
  defaultOptions = [],
  multiple=false,
  ...props
}) => {
  const [open, setOpen] = useState<boolean>(false)
  const [options, setOptions] = useState<DropdownOptionsType[]>(defaultOptions)
  const [inputValue, setInputValue] = useState<string>('')
  const [searchValue, setSearchValue] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const { setFieldValue } = useFormikContext()
  const [field, meta] = useField(name)

  useEffect(() => {
    if (inputValue.length >= (cantidadCaracteres ? cantidadCaracteres : 0)) {
      if (service && searchValue !== inputValue) {
        let active = true;
        setSearchValue(inputValue);
        setLoading(true);
        
        const fetchOptions = async () => {
          try {
            const response = await service(inputValue);
            if (response.data && response.data.length > 0) {
              setOptions(response.data);
            } else {
              setOptions(defaultOptions);
            }
          } catch (error) {
            setOptions(defaultOptions);
            console.error('Error fetching options:', error);
          } finally {
            if (active) setLoading(false);
          }
        };
        
        fetchOptions();
      }
    } else {
      setOptions(defaultOptions);
    }
  }, [inputValue]);

  return (
    <Autocomplete
      {...props}
      {...field}
      sx={{width: 400}}
      open={open}
      PopperComponent={open ? CustomPaper: undefined}
      options={options}
      loading={loading}
      multiple={multiple}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onInputChange={(event, newInputValue, reason) => {
        setInputValue(newInputValue || '');
        if (reason === 'clear') {
          setFieldValue(name, null);
          setOpen(false)
          if (onClear) {
            onClear();
          }
        }
      }}
      onOpen={() => {
        if (inputValue.length >= (cantidadCaracteres ? cantidadCaracteres : 0)) {
          setOpen(true);
        }else{
          setOpen(false)
        }
      }}
      onClose={() => {
        setOpen(false);
        setOptions(defaultOptions);
        setSearchValue('');
      }}
      onChange={(event, newValue) => {
        setFieldValue(name, newValue);
        if (onChange) {
          onChange(newValue);
        }
        if (onOptionSelect && newValue) {
          onOptionSelect();
          setOpen(false)
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size='small'
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          sx={{
            '& .MuiInputLabel-root': {
              color: '#721c31',
              '&.Mui-focused': {
                color: '#721c31',
              },
            },
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
              '& fieldset': {
                border: '2px solid lightgray',
              },
              '&:hover fieldset': {
                border: '2px solid gray',
              },
              '&.Mui-focused fieldset': {
                border: '2px solid #721c31',
              },
            },
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color='inherit' size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      componentsProps={{
        clearIndicator: { title: 'Borrar' },
        popupIndicator: { title: 'Abrir' },
      }}
    />
  )
}


export default CustomAutocompleteInput